import { useState } from "react";
import api from "../../services/api.js";

export default function AddStickyNote({
  open,
  onClose,
  userId,
  adminId,
  token,
  onSuccess,
}) {
  const [notes, setNotes] = useState("");
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!notes.trim()) return;

    try {
      setLoading(true);

      const res = await api.post(
        "/customer-notes",
        {
          user_id: userId,
          admin_id: adminId,
          notes: notes.trim(),
        },
        {
          headers: {
            Authorization: token,
          },
        }
      );

      //   const res = console.log(
      //     "/customer-notes",
      //     {
      //       user_id: userId,
      //       admin_id: adminId,
      //       notes: notes.trim(),
      //     },
      //     {
      //       headers: {
      //         Authorization: token,
      //       },
      //     }
      //   );

      if (res.data?.success) {
        setNotes("");
        onSuccess?.(res.data.data);
        onClose();
      }
    } catch (error) {
      console.error("Add sticky note failed:", error);
      alert("Gagal menambahkan catatan");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 dark:bg-black/70">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg w-full max-w-md p-4">
        {/* Header */}
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-sm font-semibold text-gray-800 dark:text-gray-100">
            Tambah Sticky Note
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 text-lg font-bold"
          >
            ×
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <textarea
            rows={5}
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
            placeholder="Tulis catatan untuk customer..."
            className="
          w-full border border-gray-300 dark:border-gray-600
          bg-white dark:bg-gray-700
          text-gray-800 dark:text-gray-100
          placeholder-gray-400 dark:placeholder-gray-400
          rounded-md p-2 text-sm
          focus:outline-none
          focus:ring-2 focus:ring-yellow-300 dark:focus:ring-yellow-400
        "
          />

          <div className="mt-4 flex justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              className="
            px-3 py-1.5 text-sm rounded-md border
            border-gray-300 dark:border-gray-600
            text-gray-700 dark:text-gray-200
            hover:bg-gray-100 dark:hover:bg-gray-700
          "
            >
              Batal
            </button>

            <button
              type="submit"
              disabled={loading}
              className="
            px-4 py-1.5 text-sm rounded-md
            bg-yellow-400 hover:bg-yellow-500
            text-gray-900
            disabled:opacity-50 disabled:cursor-not-allowed
          "
            >
              {loading ? "Menyimpan..." : "Simpan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
